import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";

import { connect } from "react-redux";
import { getDashboardCalendarEvents } from "../../../actions/dashboardActions";
import { useTranslation } from "react-i18next";
import EventDetailsModal from "./eventDetailsModal";
// const events = [
// 	{ title: "Meeting", start: new Date(), allDay: true },
// 	{
// 		title: "Lunch with falimy",
// 		start: new Date(),
// 		end: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
// 	},
// ];

const Calendar = ({
	isLoading,
	calendarEvents,
	getDashboardCalendarEvents,
	companyId,
}) => {
	const [events, setEvents] = useState([]);
	const [eventToShow, setEventToShow] = useState(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (companyId) getDashboardCalendarEvents(companyId);
	}, [companyId]);

	useEffect(() => {
		let _data = [];

		if (calendarEvents.length > 0) {
			calendarEvents.forEach((item) => {
				const startDate = new Date(item.startDateTimeStamp.toDate());
				const endDate = item.endDateTimeStamp
					? new Date(item.endDateTimeStamp.toDate())
					: null;
				_data.push({
					start: startDate,
					end: endDate,
					title: item.title,
					...item,
				});
			});

			setEvents([..._data]);
		} else {
			setEvents([]);
		}
	}, [calendarEvents]);

	return (
		<div className="stat_container">
			<div className="stat_chart_title">
				{t("dashboard_sectiontitle_overallSchedule")}
			</div>
			<FullCalendar
				headerToolbar={{
					left: "dayGridMonth,timeGridWeek,timeGridDay",
					center: "title",
					right: "today prev,next",
				}}
				plugins={[dayGridPlugin, timeGridPlugin]}
				initialView="dayGridMonth"
				events={events}
				eventContent={renderEventContent}
				editable={true}
				selectable={true}
				weekends={true}
				selectMirror={true}
				select={(x) => console.log("SELECTED:", x)}
				eventClick={(x) => setEventToShow(x.event._def)}
				eventsSet={(x) => console.log("EVENT SET:", x)}
			/>
			{eventToShow && (
				<EventDetailsModal
					event={eventToShow}
					modalCloseHandler={() => setEventToShow(null)}
				/>
			)}
		</div>
	);
};

// a custom render function
function renderEventContent(eventInfo) {
	return <div className="fc-event-main">{eventInfo.event.title}</div>;
}

const mapStateToProps = (state) => ({
	isLoading: state.dashboard.calendarEventsLoading,
	calendarEvents: state.dashboard.calendarEvents,
	companyId: state.firebase.profile.companyId,
});

export default connect(mapStateToProps, { getDashboardCalendarEvents })(
	Calendar
);
